import * as React from "react";
import { Field, makeStyles } from "@fluentui/react-components";
import { TimePicker, TimePickerProps } from "@fluentui/react-timepicker-compat";
import './timePicker.css';

const useStyles = makeStyles({
  root: {
    minWidth: "70px",
    // width:'66px'
  },
});

interface CustomTimePickerProps extends Partial<TimePickerProps> {
  isFormattedTime?: boolean;
}

export const CustomTimePicker = (props: CustomTimePickerProps) => {
  const isFormattedTime = props.isFormattedTime;

  const styles = useStyles();

  const formatDateToTimeString = (date: Date,): string => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert hours to 12-hour format
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

    return isFormattedTime ? `${hours}:${formattedMinutes}` : timeString;
  };


  return (
    <Field className={styles.root}>
      <TimePicker
        // startHour={8}
        // endHour={18}
        formatDateToTimeString={formatDateToTimeString}
        
        input={{
          style:{fontSize:14, display:'inline-block', flex:1}

        }}
        {...props}
        size="small"
      />
    </Field>
  );
};
